import './App.css';
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom"

// Bootstrap CSS
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min";

//common styles
import './styles/commonStyles.scss'

//components
import Navigation from "./components/Navbar/Navbar";
import CompareWidget from "./components/CompareWidget/CompareWidget";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Loader from "./components/Loader/Loader";
import CategoriesLoader from "./components/CategoriesLoader/CategoriesLoader";

//pages
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Cart from "./pages/Cart/Cart";
import Product from "./pages/Product/Product";
import Category from "./pages/Category/Category";
import NotFound from "./pages/NotFound/NotFound";
import MainCategory from "./pages/MainCategory/MainCategory";
import Search from "./pages/Search/Search";
import Comparison from "./pages/Comparison/Comparison";
import Favourite from "./pages/Favourite/Favourite";

// The admin area is code-split so it never ships in the public storefront bundle.
const AdminApp = lazy(() => import("./admin/AdminApp"));

// Storefront chrome (navbar + footer + compare widget) wraps every public route.
const StorefrontLayout = () => (
  <>
    <Navigation />
    <CompareWidget />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop/>
        <CategoriesLoader/>
        <Routes>
          {/* Admin area — separate layout, lazy-loaded */}
          <Route
            path="/admin/*"
            element={
              <Suspense fallback={<Loader />}>
                <AdminApp />
              </Suspense>
            }
          />

          {/* Public storefront */}
          <Route element={<StorefrontLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/comparison" element={<Comparison/>} />
            <Route path='/products/:productId' element={<Product />} />
            <Route path='/:mainCategory/:categoryId/' element={<Category />} />
            <Route path='/:mainCategory/' element={<MainCategory />} />
            <Route path='/search/' element={<Search />} />
            <Route path='/favourite/' element={<Favourite />} />
            <Route path='/404' element={<NotFound />} />
            <Route path='*' element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
